'use client';

import React, { useState, useEffect } from 'react';

const CountdownBanner: React.FC = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (!isHydrated) return;

    const calculateTimeLeft = () => {
      const targetDate = new Date('2026-04-17T00:00:00');
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [isHydrated]);

  if (!isHydrated) {
    return (
      <div className="bg-gradient-to-r from-primary to-secondary rounded-lg shadow-lg p-8 mb-6">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-headline font-bold text-white mb-4">
            Countdown to April 17th, 2026
          </h2>
          <div className="flex justify-center gap-4 md:gap-8">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="text-center">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 md:p-6 min-w-20 md:min-w-24">
                  <div className="text-3xl md:text-4xl font-headline font-bold text-white">
                    --
                  </div>
                  <div className="text-xs md:text-sm font-body text-white/80 mt-2">
                    Loading
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-primary to-secondary rounded-lg shadow-lg p-8 mb-6 breathing-animation">
      <div className="text-center">
        <h2 className="text-2xl md:text-3xl font-headline font-bold text-white mb-2">
          Countdown to April 17th, 2026
        </h2>
        <p className="text-sm md:text-base font-body text-white/90 mb-6">
          Join millions worldwide in choosing peace over hostility
        </p>
        <div className="flex justify-center gap-4 md:gap-8">
          <div className="text-center">
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 md:p-6 min-w-20 md:min-w-24">
              <div className="text-3xl md:text-4xl font-headline font-bold text-white">
                {timeLeft.days}
              </div>
              <div className="text-xs md:text-sm font-body text-white/80 mt-2">
                Days
              </div>
            </div>
          </div>
          <div className="text-center">
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 md:p-6 min-w-20 md:min-w-24">
              <div className="text-3xl md:text-4xl font-headline font-bold text-white">
                {timeLeft.hours}
              </div>
              <div className="text-xs md:text-sm font-body text-white/80 mt-2">
                Hours
              </div>
            </div>
          </div>
          <div className="text-center">
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 md:p-6 min-w-20 md:min-w-24">
              <div className="text-3xl md:text-4xl font-headline font-bold text-white">
                {timeLeft.minutes}
              </div>
              <div className="text-xs md:text-sm font-body text-white/80 mt-2">
                Minutes
              </div>
            </div>
          </div>
          <div className="text-center">
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 md:p-6 min-w-20 md:min-w-24">
              <div className="text-3xl md:text-4xl font-headline font-bold text-white">
                {timeLeft.seconds}
              </div>
              <div className="text-xs md:text-sm font-body text-white/80 mt-2">
                Seconds
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownBanner;